import { HttpError, sendAuthedChatRequest } from './httpClient.js'

const JSON_OBJECT_DELIMITER = 'jsonobjectdelimiter'

export const requestGemini = async ({
  messages,
  attachments,
  aiVersion,
  tools,
  returnReader = false,
  streamText = false,
  signal,
  usageContext
}) => {
  if (!messages || messages.length === 0) {
    throw new Error('Cannot make AI call with empty messages.')
  }

  const CHAT_API_URL = process.env.VUE_APP_CHAT_API_URL

  const requestBody = {
    aiVersion,
    messages,
    attachments,
    tools,
    streamText,
    usageContext
  }

  try {
    const response = await sendAuthedChatRequest(CHAT_API_URL, requestBody, signal)

    let responseText
    if (!streamText && !returnReader) {
      responseText = await response.text()
    }

    if (!streamText && !returnReader && !responseText?.includes(JSON_OBJECT_DELIMITER)) {
      const response = JSON.parse(responseText)
      if (response?.error?.message) {
        throw new Error(response.error.message)
      }
    }

    if (returnReader) {
      if (!response.body) {
        throw new Error('Response body is null, cannot return reader.')
      }
      return response.body.getReader()
    }

    const rawText = responseText.replace(JSON_OBJECT_DELIMITER, '')

    if (rawText === null || typeof rawText === 'undefined') {
      return ''
    }

    let parsableJsonString = rawText ? rawText.trim() : ''

    if (parsableJsonString) {
      const jsonRegex = /^```(?:json)?\s*([\s\S]*?)\s*```$/
      const match = parsableJsonString.match(jsonRegex)

      if (match && match[1]) {
        parsableJsonString = match[1].trim()
      } else {
        if (parsableJsonString.startsWith('```') && parsableJsonString.endsWith('```')) {
          const simplerStrip = parsableJsonString.substring(3, parsableJsonString.length - 3).trim()
          if (simplerStrip.startsWith('{') || simplerStrip.startsWith('[')) {
            parsableJsonString = simplerStrip
          }
        }
      }
    }

    const parsedResponse = JSON.parse(parsableJsonString)
    if (parsedResponse?.message && parsedResponse.message.includes('Failed to parse AI response')) {
      throw new Error(parsedResponse.message)
    }
    return parsedResponse
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error
    }

    if (error instanceof HttpError) {
      throw new Error(`AI Lambda service call failed: ${error.message}. Server detail: ${error.body || 'N/A'}`)
    }

    throw new Error(`AI Lambda service call failed: ${error.message}`)
  }
}
